import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiptComponent } from './receipt.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ReceiptComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class ReceiptModule { }
